<template>
  <div :class="classnames">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'tabs-content-item'

  const modifiers = {
    isFocused: 'is-focused'
  }

  export default {
    name: 'TabsContentItem',
    components: {},
    mixins: [ bem ],
    props: {
      focusedTabId: {
        type: Number
      },
      id: {
        type: Number
      }
    },
    data: function () {
      return {}
    },
    computed: {
      isFocused: function () {
        const isFocused = this.focusedTabId === this.id

        return isFocused
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const isFocused = this.isFocused && modifiers.isFocused

        return [ isFocused ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Tabs/TabsContentItem.vue